import { useState } from 'react';
import { Flex, Button, Box } from '@chakra-ui/react';
import { TimePicker } from './TimePicker';

export const Day = ({ day, onChange = () => {} }) => {
  const [isEnabled, toggleEnabled] = useState(!day?.disabled);

  return (
    <Flex mb="12px" pl="3px">
      <Button
        minW="75px"
        fontWeight="semiBold"
        boxShadow={
          isEnabled
            ? '0px 0px 0px 4px #DFE9FE'
            : '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
        }
        _focus={{
          boxShadow: isEnabled
            ? '0px 0px 0px 4px #DFE9FE'
            : '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        }}
        border={isEnabled ? '1px solid #444CE7' : '1px solid #D0D5DD'}
        variant={'secondary'}
        onClick={() => {
          toggleEnabled((prev) => {
            onChange({ id: day?.id, disabled: !!prev });
            return !prev;
          });
        }}
      >
        {day?.label}
      </Button>
      <Box ml="12px" flex="1">
        <TimePicker day={day} disabled={!isEnabled} onChange={onChange} />
      </Box>
    </Flex>
  );
};
